"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const prefetcher_1 = require("../filter/prefetcher");
const react_query_1 = require("@tanstack/react-query");
const fetchData = async (props) => {
    try {
        let queryUrl = '';
        queryUrl = process.env.NODE_ENV === 'development' ? '/api/gatsby-plugin-atollon/go' : '/go';
        if (queryUrl) {
            return fetch(queryUrl, {
                method: props?.verb || 'GET',
                body: props?.data ? JSON.stringify(props.data) : undefined
            }).then(res => res.json());
        }
    }
    catch (e) {
        return null;
    }
    return null;
};
const useUser = () => {
    const mutation = (0, react_query_1.useMutation)({
        mutationKey: ['user'],
        mutationFn: async (props) => {
            const endpointData = await fetchData(props);
            if (endpointData.reason) {
                throw new Error(`${endpointData.message} - ${endpointData.reason}`);
            }
            if (endpointData) {
                return endpointData.meta?.user || null;
            }
            return null;
        },
        onSuccess: data => {
            prefetcher_1.queryClient.setQueryData(['user'], data);
        }
    }, prefetcher_1.queryClient);
    const { isLoading, error, data: foundData } = (0, react_query_1.useQuery)({
        queryKey: ['user'],
        queryFn: async () => {
            const endpointData = await fetchData();
            if (endpointData.reason) {
                throw new Error(`${endpointData.message} - ${endpointData.reason}`);
            }
            if (endpointData) {
                return endpointData.meta?.user || null;
            }
            return null;
        },
        refetchInterval: 60000 * 2 // 5 mins
        // re-fetch interval
    }, prefetcher_1.queryClient);
    const updateUser = (data) => {
        mutation.mutate({ verb: 'PUT', data });
    };
    const signOut = () => {
        mutation.mutate({ verb: 'DELETE' });
    };
    return {
        id: foundData?.id,
        data: foundData?.data || null,
        email: foundData?.email || null,
        firstName: foundData?.firstName || null,
        lastName: foundData?.lastName || null,
        loading: isLoading,
        authenticated: !!(foundData?.authenticated),
        error: error?.message || null,
        updateUser,
        signOut
    };
};
exports.default = useUser;
//# sourceMappingURL=use-user.js.map